// Get suggested products based on the current product
// Priority: same brand/band/game > same genre > same category > random
// Returns up to `count` products, excluding the current one

function getBrandName(product) {
  if (product.band) return product.band;
  if (product.game) return product.game;
  return product.name.replace(/\s*Oversized Tee$/i, '').trim();
}

export function getSuggestions(currentProduct, allProducts, count = 2) {
  const others = allProducts.filter(p => p.id !== currentProduct.id);
  if (others.length === 0) return [];

  const currentBrand = getBrandName(currentProduct);
  const suggestions = [];
  const used = new Set();

  function add(product) {
    if (used.has(product.id) || product.id === currentProduct.id) return false;
    used.add(product.id);
    suggestions.push(product);
    return suggestions.length >= count;
  }

  // 1. Same brand/band/game (different product from same band/game)
  for (const p of others) {
    if (getBrandName(p) === currentBrand) {
      if (add(p)) return suggestions;
    }
  }

  // 2. Same genre (music only)
  if (currentProduct.genre) {
    for (const p of others) {
      if (p.genre === currentProduct.genre) {
        if (add(p)) return suggestions;
      }
    }
  }

  // 3. Same category
  for (const p of others) {
    if (p.category === currentProduct.category) {
      if (add(p)) return suggestions;
    }
  }

  // 4. Random from anything remaining
  const remaining = others.filter(p => !used.has(p.id));
  const shuffled = [...remaining].sort(() => Math.random() - 0.5);
  for (const p of shuffled) {
    if (add(p)) return suggestions;
  }

  return suggestions;
}
